import React, {useCallback, useContext, useRef} from 'react';
import {fillInitialClickedFilters} from '../../helper/filter-helper';
import {yieldToMain} from '../../ArticleOverviewHelper';
import {articleOverviewStaticContext} from '@article-overview/components/ArticleOverviewStatic.jsx';
import {Icon, Tooltip, CheckboxGroup} from '@bonprix/design-system';

function Checkbox({filterOptionChange, identifier, filterOptions, trackingId, hideNumberOfItems}) {
    const clickedFilters = useRef(fillInitialClickedFilters(filterOptions));
    const {texts} = useContext(articleOverviewStaticContext);

    const isTransparencyFilter = identifier === 'a_fabricqual_light';
    const isSpecialSizeFilter = identifier === 'a_length_trous_knl';

    const getTooltipContent = useCallback(
        (optionName) => {
            if (!isTransparencyFilter) return null;

            const tooltipMap = {
                transparent: texts.filter_transparent_description,
                halbtransparent: texts.filter_halbtransparent_description,
                verdunkelnd: texts.filter_verdunkelnd_description,
                abdunkelnd: texts.filter_abdunkelnd_description,
                blickdicht: texts.filter_blickdicht_description,
            };
            const content = tooltipMap[optionName] || null;

            if (content) {
                return <div dangerouslySetInnerHTML={{__html: content}}></div>;
            }
            return null;
        },
        [isTransparencyFilter, texts],
    );

    const handleChange = useCallback(
        (newValues) => {
            clickedFilters.current = newValues;
            yieldToMain(() => filterOptionChange(identifier, trackingId, newValues));
        },
        [filterOptionChange, identifier, trackingId],
    );

    const renderLabel = (name, numberOfItems) => (hideNumberOfItems ? name : `${name} (${numberOfItems})`);

    const renderFilterOption = (option) => {
        const tooltipContent = getTooltipContent(option.name);
        return (
            <div className="flex items-center">
                <CheckboxGroup.Item label={renderLabel(option.name, option.numberOfItems)} value={option.value} />
                {tooltipContent && (
                    <Tooltip content={tooltipContent} zIndex={10001}>
                        <div className={'w-10 h-10 py-1.5'}>
                            <Icon variant="info" className={'border-2 rounded-full ml-2'}></Icon>
                        </div>
                    </Tooltip>
                )}
            </div>
        );
    };

    if (!filterOptions || filterOptions.length === 0) return null;

    return (
        <div className={isSpecialSizeFilter ? 'pt-4' : ''}>
            <CheckboxGroup label="" values={clickedFilters.current} onChange={handleChange}>
                {filterOptions.map((option) => renderFilterOption(option))}
            </CheckboxGroup>
        </div>
    );
}

export default React.memo(Checkbox);
